import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from '@atlaskit/button';
import { AnalyticsEventSource, ScreenEventAnalytics } from '@atlassian/temp-analytics';
import { AddPaymentMethod, AppContent, AppPage, ErrorComponents, useApplicationContext } from '@css-xp/base';
import { withErrorWrapper } from '@css-xp/ppc-wrapper';
import { failureMessage, getSupportUrl } from '@css-xp/ppc-common';
import { useTitle } from '@css-xp/ppc-custom-hooks';
import { PPC_PAGE_TITLE } from '@css-xp/ppc-constants';
import TickImage from '@css-xp/base/assets/img/tick-image-minified.svg';
import './add-payment-method-page.scss';

const renderUnauthorized = () => {
  const Unauthorized = withErrorWrapper(ErrorComponents.Unauthorized);
  return <Unauthorized />;
};

export const AddPaymentMethodPage = () => {
  const context = useApplicationContext();
  useTitle(PPC_PAGE_TITLE.ADD_PAYMENT_METHOD);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const transactionAccountId = queryParams.get('transactionAccount');
  const [addPaymentSuccessful, setAddPaymentSuccessful] = React.useState(false);
  const partnerAccount = context?.partnerAccounts?.find(
    (account: { transactionAccountId: string }) => account.transactionAccountId === transactionAccountId
  );
  return (
    <AppPage className="app-page-v2" title="Add Payment Method | Partner Purchasing Center">
      <ScreenEventAnalytics
        event={{
          name: AnalyticsEventSource.PARTNER_ADD_PAYMENT_METHOD_SCREEN,
          attributes: {
            transactionAccountId,
          },
        }}
      />
      <AppContent>
        {!transactionAccountId || !partnerAccount ? (
          renderUnauthorized()
        ) : (
          <div className="ppc-add-payment-method-page-container">
            {addPaymentSuccessful ? (
              <div className="successful-message-container">
                {/* @ts-expect-error type mismatch between imported svg and img src prop type */}
                <img src={TickImage} alt="" />
                <h1 className="success-message" data-testid="ppc.add-payment-page.success-message">
                  Your payment method has been successfully added
                </h1>
                {/*<Button*/}
                {/*  onClick={() => {*/}
                {/*    // For this to work the "Add payment method page" should be opened using window.open() method*/}
                {/*    window.close();*/}
                {/*  }}*/}
                {/*  className="mt-16"*/}
                {/*>*/}
                {/*  Close tab*/}
                {/*</Button>*/}
              </div>
            ) : (
              <AddPaymentMethod
                txaId={transactionAccountId as string}
                onCancel={() => ''}
                overrideOnUpdateSuccess={() => {
                  setAddPaymentSuccessful(true);
                }}
                successMessage={'Successful'}
                failureMessage={failureMessage()}
                header={'Add your payment method'}
                subHeader={
                  <span data-testid="ppc.add-payment-page.subheader">
                    We accept all major debit/credit cards. For help with other ways to pay, contact {getSupportUrl()}.
                  </span>
                }
              />
            )}
          </div>
        )}
      </AppContent>
    </AppPage>
  );
};
